// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "b335bf3880bc8e2c85c17647fafd72ce21d438f6/static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"83cd5b92","98":"c3469f9b","157":"5fa962a7","215":"28b12c6b","515":"941628b2","777":"dfb468f1","952":"a8f7192d"}[chunkId] + ".chunk.js";
};